import type { ReactNode } from 'react';
import { Breadcrumb, type BreadcrumbItem } from './Breadcrumb';
import { DocumentTitle } from './DocumentTitle';
import classes from './PageHeader.module.css';

export interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  /** Parent pages; a string title is appended as the current page. */
  breadcrumb?: { label: string; to: string }[];
  actions?: ReactNode;
  /** The browser tab title; defaults to `title` when that is a string. */
  documentTitle?: string;
}

export function PageHeader({
  title,
  subtitle,
  breadcrumb,
  actions,
  documentTitle,
}: PageHeaderProps) {
  const crumbs: BreadcrumbItem[] | null = breadcrumb?.length
    ? [...breadcrumb, ...(typeof title === 'string' ? [{ label: title }] : [])]
    : null;
  const tabTitle = documentTitle ?? (typeof title === 'string' ? title : undefined);

  return (
    <div className={classes.wrap}>
      {tabTitle && <DocumentTitle title={tabTitle} />}
      {crumbs && <Breadcrumb items={crumbs} />}
      <header className={classes.header}>
        <div className={classes.titles}>
          <h1 className={classes.title}>{title}</h1>
          {subtitle && <div className={classes.subtitle}>{subtitle}</div>}
        </div>
        {actions && <div className={classes.actions}>{actions}</div>}
      </header>
    </div>
  );
}
